<div (click)="dismissAll()" class="af-action-sheet-backdrop" data-test="dismiss-backdrop"></div>
<div class="af-action-sheet" role="dialog">
    <div *ngIf="header" class="af-action-sheet-header">{{ header }}</div>
    <div class="af-action-sheet-content">
        <ng-content></ng-content>
    </div>
    <button (click)="dismissAll()" class="af-action-sheet-footer" type="button" data-test-="dismiss-button">{{ cancelText }}</button>

</div>
